/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';
import * as Permission from '../util/Permission';
import {RuleTypes} from './ScenarioChannelDefRuleType';

export default declareEntity({
    entity: 'scenarioDefs2ChannelDefs',
    graphQL: "ScenarioDefs2ChannelDef",
    name: "Scenario Definition to Application Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: "scenarioDefs2ChannelDefs",
    isPublic: true,
    defaultOrder: ['channelDef_id'],
    onModify: ['scenarioDef'],
    fields: (types) => {
        return {
            id: {
                name: "Rule ID",
                type: "id",
                primaryKey: true,
                required: true,
                compositeKey: true,
                userEditable: false,
                defaultValue: () => {
                    return uuidv4();
                },
                isPublic: true,
            },
            scenarioDef: {
                name: "Scenario Definition",
                to: () => types['scenarioDefs'],
                type: "relation",
                required: true,
                parent: true,
                compositeKey: true,
                hiddenCreate: true,
                defaultValue: (scenarioDef) => {
                    return scenarioDef['id'];
                },
                isPublic: true,
            },
            ruleType: {
                name: "Rule Type",
                type:  "enum",
                values: RuleTypes,
                isPublic: true,
            },
            key: {
                name: "Key",
                type: "string",
                defaultValue: "",
                isPublic: true,
            },
            channelDef: {
                name: "Application Definition",
                to: () => types['channelDefs'],
                type: "relation",
                required: true,
                isPublic: true,
            },
            doNotShowToUser: {
                name: "Do not show to user",
                type: "boolean",
                defaultValue: false,
                isPublic: true,
            },
            showContactUs: {
                name: "Show Contact Us",
                type: "boolean",
                defaultValue: false,
                isPublic: true,
            },
            requiresCaching: {
                name: "Requires activated caching",
                type: "boolean",
                defaultValue: false,
                isPublic: true,
            },
            requiresWritePermission: {
                name: "Requires write permission for API",
                type: "boolean",
                defaultValue: false,
                isPublic: true,
            },
            scenarioDescription: {
                name: "Scenario description",
                type: "text",
                translatable: true,
                isPublic: true,
            },
            replaceScenarioDescription: {
                name: "Replace Scenario description",
                type: "enum",
                defaultValue: "append",
                values: {
                    "append": {
                        name: "Append at end",
                    },
                    "replace": {
                        name: "Replace description",
                    },
                },
                isPublic: true,
            },
            order: {
				name: "Order",
				type: "int",
				defaultValue: 0,
				required: false,
				isPublic: true,
			},
        };
    }
});
